<script>
import BarList from '../components/bar-list'
import ivancmForm from './ivancm-form'
import { getText, formatDate, formatValue } from '../shared/utils'
import { SysVars } from '../main';

export default {
  data() {

    return {
      showForm: false, //exibe a tela de manutencao
      crud: '', //indica o modo de edicao: incluir, alterar, visualizar, etc
      id: '',
      metadata: this.$store.getters.getEntities.metadata,
      filter: '',
    }
  },

  computed: {
    ivancmList: function () {
      return this.$store.getters.getivancmList
    }
  },

  methods: {
    handleEdit(id) {
      //abre a tela de edicao
      this.crud = SysVars.crudU;
      this.id = id
      this.showForm = true;
    },

    handleNew() {
      //inclusao de registro
      this.crud = SysVars.crudI
      this.id = ''
      this.showForm = true;
    },

    closeForm() {
      this.showForm = false
      this.loadData()
    },

    search(value) {
      //efetua a pesquisa
      this.filter = '{"$or":[{"ncm":{"$like":"%25' + value + '%25"}},{"cclass":{"$like":"%25' + value + '%25"}}]}'
      this.loadData()
    },

    loadData() {
      this.$store.dispatch('loadivancm', { filter: this.filter })
    }

  },

  components: {
    BarList, ivancmForm
  },

  created() {
    this.showForm = false
    this.loadData()
  }

}

</script>

<template>
  <div>
    <div id="list" v-show="!showForm">
      <bar-list :refresh-button="true" :new-button="true" :pdf-button="false" :xls-button="false"
        single-entity="NCM x CST-IBS/CBS" plural-entity="NCM`s x CST-IBS/CBS" @search="search" @new="handleNew"
        @refresh="loadData" title-search="Pesquise pelo NCM ou pelo Cod.class">
      </bar-list>
      <br>
      <div class="default-container">
        <alert v-if="ivancmList.length == 0" type="norecord"></alert>
        <div class="mainbox" v-for="ivancm in ivancmList" v-bind:key="ivancm.uf">
          <div class="mark-green"></div>
          <div class="box">
            <div class="row">
              <div class="col-md-10 col-12">
                <span class="lbl-title-produto">{{ ivancm.ncm }} ({{ ivancm.cclass }}) </span>
              </div>
              <div class="col-md-2 col-12">
                <bar-grid :options="{ barDefault: true, btnView: true, btnEdit: true }" :moreActions="[]"
                  v-on:edit="handleEdit(ivancm.codivancm)" v-on:view="handleEdit(ivancm.ivancm, true)">
                </bar-grid>
              </div>
            </div>
            <div class="row">
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> {{ metadata.ivancm.ncm.label }} </label><span class="data-list">{{
                    ivancm.ncm
                }}</span>
              </div>
              <div class="col-md-2 col-6" style="float: left">
                <label class="lbl-list"> {{ metadata.ivancm.cclass.label }} </label><span class="data-list">{{
                    ivancm.cclass
                }}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <ivancm-form v-if="showForm" :index="this.id" :crud="this.crud" v-on:closeform="closeForm"></ivancm-form>
  </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/ivancm-list.vue